import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "@/locale/index.js";
import axios from "axios";
import VueAxios from "vue-axios";
import Primevue from "primevue/config";
import ToastService from "primevue/toastservice";
import VueGoogleMaps from "@fawmi/vue-google-maps";


axios.defaults.baseURL = "https://test.join-homra.com/api/v1/";
axios.defaults.headers = {
  "Accept-Language": localStorage.getItem("lang") || "ar",
  Accept: "application/json",
};

//add css
import "@/assets/css/main.scss";

//primeflex
import "primeflex/primeflex.css";

//prime vue
import "primevue/resources/themes/aura-light-pink/theme.css";

//prime icons
import "primeicons/primeicons.css";

//fotawesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(fas, fab, far);

createApp(App)
  .use(router)
  .use(i18n)
  .use(Primevue)
  .use(VueAxios, axios)
  .use(VueGoogleMaps, {
    load: {
      key: "AIzaSyBg22oXBMR_M_ZxIkQKesoKSZXDPkuSSNA",

      libraries: "places",
    },
  })
  .use(ToastService)
  .component("fa", FontAwesomeIcon)
  .mount("#app");
